import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "schq_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* ignore */ }
  }, []);
  const decide = (val) => { try { localStorage.setItem(KEY, val); } catch { /* ignore */ } setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-3 rounded-xl border border-slate-700 bg-[#0d1420] p-4 shadow-2xl sm:flex-row sm:items-center">
        <Cookie className="h-5 w-5 shrink-0 text-amber-400" />
        <p className="flex-1 text-xs leading-relaxed text-slate-200">
          We use essential cookies to run SiteControlHQ and optional analytics to improve it. See our{" "}
          <Link to="/privacy" className="text-cyan-400 hover:underline">Privacy Policy</Link>.
        </p>
        <div className="flex shrink-0 items-center gap-2">
          <button data-testid="cookie-decline" onClick={() => decide("essential")} className="rounded-full border border-slate-600 px-4 py-1.5 text-xs text-slate-300 hover:border-slate-400">Essential only</button>
          <button data-testid="cookie-accept" onClick={() => decide("all")} className="btn-amber rounded-full px-4 py-1.5 text-xs">Accept all</button>
        </div>
      </div>
    </div>
  );
}
